// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapIcon, BootstrapImage } from '../../../dsl/front';
import { ImageRatio } from '../../_contracts';
import { prepareImage } from '../../_filters';
let Editor = class Editor extends Vue {
    /**
     * Determines icon name.
     */
    iconName(key) {
        const socialIconMap = {
            facebook: 'social-facebook',
            instagram: 'social-instagram',
            linkedin: 'social-linkedin',
            youtube: 'social-youtube',
            twitter: 'social-x',
            email: 'mail-new',
            mail: 'mail-new'
        };
        if (socialIconMap[key]) {
            return socialIconMap[key];
        }
        return `${key}-fill`;
    }
    /**
     * Determines uniq link id.
     */
    linkId(index) {
        return `link-${index}`;
    }
    /**
     * Determines editor links.
     */
    get links() {
        const links = this.editor.links;
        if (!links) {
            return;
        }
        return Object.entries(links).filter(([key, value]) => !!value);
    }
    /**
     * Determines editor author
     * avatar image.
     *
     */
    get authorAvatar() {
        if (typeof this.editor === 'undefined' || typeof this.editor.avatar === 'undefined') {
            return;
        }
        return prepareImage(this.editor.avatar, ImageRatio.Portrait, 510, this.isLazy);
    }
    onShare() {
        navigator.share({
            url: window.location.href
        });
    }
};
__decorate([
    Prop({
        type: Object,
        required: true
    })
], Editor.prototype, "editor", void 0);
__decorate([
    Prop({
        type: String,
        required: false,
        default: 'h3'
    })
], Editor.prototype, "nameTag", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    })
], Editor.prototype, "isLazy", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    })
], Editor.prototype, "showAbout", void 0);
Editor = __decorate([
    Component({
        name: 'Editor',
        components: {
            BootstrapImage,
            BootstrapIcon
        },
        template: `
    <div class="editor row m-0">

    <div class="editor__avatar col-12 col-md-4 p-0">
      <BootstrapImage v-if="authorAvatar" class="editor__avatar__image" v-bind="authorAvatar"/>
    </div>

    <div class="editor__meta col-12 col-md-6 ps-md-6">
      <component class="editor__meta__name" :is="nameTag">
        {{ editor.firstName }} {{ editor.lastName }}
      </component>

      <p class="editor__meta__position mt-1">
        {{ editor.position }}
      </p>

      <div class="mt-5">
        <div v-if="links" class="editor__meta-links">
          <a
            v-for="([key, value], index) in links"
            :href="value"
            :key="linkId(index)"
            target="_blank"
            class="link"
          >
            <BootstrapIcon :name="iconName(key)"/>
          </a>
          <a v-if="editor.email" :href="'mailto:' + editor.email" class="link">
            <BootstrapIcon name="mail-new"/>
          </a>
        </div>
      </div>

      <div v-if="editor.description && showAbout" v-html="editor.description" class="mt-6"/>
    </div>

    <div class="col-12 col-md-2 editor__meta__panel">
      <span class="editor__meta__panel-share" @click="onShare">
        <span class="editor__meta__panel-share__label">{{ $t('modules.author.share') }}</span>
        <BootstrapIcon name="share-new"/>
      </span>
    </div>

    </div>
  `
    })
], Editor);
export { Editor };
export default Editor;
